import React, { useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Close from '@material-ui/icons/Close';
import Fab from '@material-ui/core/Fab';
import { useQuery } from 'react-apollo';

import TabSelector from './components/TabSelector';
import InfosPrincipais from './components/InfosPrincipais';
import DadosBancarios from './components/DadosBancarios';
import BraspagAnexos from './components/BraspagAnexos';
import ModalDadosPagamentoAlternativoProfissional from '../dados-pagamento-alternativo/ModalDadosPagamentoAlternativoProfissional';

import Colors from '../../../../theme/Colors';
import { ModalDetalhesProfissionalStyles } from './styles.js';

import { FIND_DADOS_BRASPAG_PROFISSIONAL_SAUDE, FIND_BY_ID_PROFISSIONAL_SAUDE_DADOS_PAGAMENTO, UTILIZA_API_PAGAMENTOS_ALTERNATIVO_POR_UNIDADE } from '../../../../graphql/queryes';

const ModalDetalhesProfissionalSaude = ({
  profissionalDeSaude,
  onClose,
  classes,
}) => {
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);

  const responseBraspagProfissionalSaude = useQuery(
    FIND_DADOS_BRASPAG_PROFISSIONAL_SAUDE,
    {
      variables: { profissionalSaudeId: profissionalDeSaude?.id },
      skip: !profissionalDeSaude?.id,
    }
  );

  const { data: utilizaApiData } = useQuery(UTILIZA_API_PAGAMENTOS_ALTERNATIVO_POR_UNIDADE, {
    variables: { unidadeId: profissionalDeSaude?.unidades?.[0]?.id },
    skip: !profissionalDeSaude?.unidades?.[0]?.id,
  });
  const utilizaApiPagamentosAlternativo = utilizaApiData?.utilizaApiPagamentosAlternativoPorUnidade;

  const { data: dadosPagamentoData, refetch: refetchDadosPagamento } = useQuery(
    FIND_BY_ID_PROFISSIONAL_SAUDE_DADOS_PAGAMENTO,
    {
      variables: { id: profissionalDeSaude?.id },
      skip: !profissionalDeSaude?.id || !utilizaApiPagamentosAlternativo,
    }
  );

  const profissionalComDadosPagamento = dadosPagamentoData?.findByIdProfissionalSaude;

  const dadosBraspagProfissional =
    responseBraspagProfissionalSaude?.data?.findByDadosBraspagProfissionalSaude;

  const TAB_OPTIONS = [
    { label: 'Informações principais' },
    { label: 'Dados bancários' },
    { label: 'Documentos' },
  ];

  if (!dadosBraspagProfissional) {
    TAB_OPTIONS.pop();
  }

  if (!dadosBraspagProfissional?.profissionalSaudeBraspagAnexo?.length) {
    TAB_OPTIONS.pop();
  }

  if (utilizaApiPagamentosAlternativo) {
    TAB_OPTIONS.push({ label: 'Pagamento Alternativo' });
  }

  const pagamentoAlternativoTabIndex = TAB_OPTIONS.findIndex(t => t.label === 'Pagamento Alternativo');

  const tabContentByIndex = {
    0: (
      <InfosPrincipais
        profissionalDeSaude={profissionalDeSaude}
        dadosBraspagProfissional={dadosBraspagProfissional}
      />
    ),
    1: <DadosBancarios dadosBraspagProfissional={dadosBraspagProfissional} />,
    2: (
      <BraspagAnexos
        dadosBraspagProfissional={
          dadosBraspagProfissional?.profissionalSaudeBraspagAnexo
        }
      />
    ),
    ...(pagamentoAlternativoTabIndex >= 0 ? {
      [pagamentoAlternativoTabIndex]: (
        <ModalDadosPagamentoAlternativoProfissional
          profissional={profissionalComDadosPagamento || profissionalDeSaude}
          onClose={null}
          onSuccess={refetchDadosPagamento}
        />
      ),
    } : {}),
  };
  const renderTabContent = tabContentByIndex[selectedTabIndex || 0];

  return (
    <div className={classes.container}>
      <div className={classes.header}>
        <span className={classes.headerTitle}>{profissionalDeSaude.nome}</span>
        <Fab className={classes.closeIcon} onClick={onClose}>
          <Close fontSize="small" />
        </Fab>
      </div>
      <TabSelector
        selectedColor={Colors.primary.contrastText}
        baseColor={
          !dadosBraspagProfissional
            ? Colors.primary.contrastText
            : Colors.commons.gray6
        }
        onSelect={(index) => setSelectedTabIndex(index)}
        selectedTabIndex={selectedTabIndex}
        tabsOptions={TAB_OPTIONS}
      />
      <div className={classes.gridContainer}>
        <div
          className={
            selectedTabIndex === 0
              ? classes.content
              : classes.contentSecondaryTab
          }
        >
          {renderTabContent}
        </div>
      </div>
    </div>
  );
};

export default withStyles(ModalDetalhesProfissionalStyles)(
  ModalDetalhesProfissionalSaude
);
